<script setup lang="ts">
import { reactive, computed } from 'vue'
import { routerConstants } from '@/constants/routers/common'
import { findColorValue } from '@/utils/style'
import { useSharesActions } from '@/utils/shares'
import { ComputableObject } from '@/types/global'
import { IResultTemplate } from '@/types/common/questions'
import Image from '@/components/atoms/Image/index.vue'
import PhotographerRequest from '@/components/molecules/PhotographerRequest/index.vue'

const props = withDefaults(
  defineProps<{
    isShares: boolean
  }>(),
  {
    isShares: false,
  }
)
const states = reactive<ComputableObject<IResultTemplate>>({
  isShares: computed(() => props.isShares),
})

const { PATH } = routerConstants.LOCATION
const sharesUrl = useSharesActions(PATH.QUESTIONS_INDEX, 'おすすめフォトグラファー')
</script>

<template>
  <div class="result-template">
    <h1 class="result-template-head">
      <a href="/">
        <Image
          :path-pc="'/assets/images/header-logo.png'"
          :path-pc-webp="'/assets/images/header-logo.webp'"
          :width-pc="214"
          :height-pc="48"
          :is-lazy="false"
          :alt="'出張撮影・出張カメラマンマッチングサイト OurPhoto'"
        ></Image>
      </a>
    </h1>
    <div class="result-template-content">
      <slot />
    </div>
    <div class="result-template-request">
      <PhotographerRequest />
    </div>
    <div class="result-template-bottom">
      <div v-if="states.isShares" class="result-template-share">
        <div class="result-template-share-title">診断結果をシェア</div>
        <div class="result-template-share-list">
          <a class="result-template-share-item" :href="sharesUrl.createFacebookShareUrl()" target="_blank">
            <img :src="'/assets/images/iconmonstr-facebook-4.svg'" alt="facebook" />
          </a>
          <a class="result-template-share-item" :href="sharesUrl.createTwitterShareUrl()" target="_blank">
            <img :src="'/assets/images/iconmonstr-twitter-4.svg'" alt="twitter" />
          </a>
          <a class="result-template-share-item" :href="sharesUrl.createLineShareUrl()" target="_blank">
            <img :src="'/assets/images/iconmonstr-line-4.svg'" alt="line" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/styles/mixins/share' as share-mixins;
.result-template {
  background-color: #eee;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  @media (max-width: 767px) {
    padding: 0 15px;
    justify-content: start;
  }
  &-head {
    margin-top: 30px;
    margin-bottom: 0;
    @media (max-width: 767px) {
      margin-top: 20px;
    }
    img {
      width: 160px;
      @media (max-width: 767px) {
        width: 120px;
      }
    }
  }
  &-content {
    width: 100%;
    max-width: 1200px;
    margin-top: 30px;
    padding: 40px 40px 50px;
    background-color: #fff;
    box-shadow: 0px 2px 6px #0000001f;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    @media (max-width: 767px) {
      max-width: inherit;
      margin-top: 20px;
      padding: 30px 15px;
    }
  }
  &-bottom {
    width: 100%;
    margin-top: 80px;
    @media (max-width: 767px) {
      margin-top: 40px;
    }
  }
  &-share {
    margin-bottom: 20px;
    @include share-mixins.sns-share-questions;
  }
  .result-template-request {
    width: 100%;
    max-width: 1200px;
    padding: 40px 40px 50px;
    border-radius: 4px;
    box-sizing: border-box;
    background-color: v-bind('findColorValue("light-cream")');
    box-shadow: 0px 2px 6px #0000001f;
    border-radius: 0 0 4px 4px;
    @media (max-width: 767px) {
      max-width: inherit;
      padding: 30px 15px;
    }
  }
}
</style>
